// Author liang gang qiang
// Date 2021-11-02 16:51:39

class MintalMesPrdCraftConfig {
constructor({
        id = null,
        craftId = '',
        craftName = '',
        locationId = '',
        locationName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.craftId = craftId;
    this.craftName = craftName;
    this.locationId = locationId;
    this.locationName = locationName;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdCraftConfig();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdCraftConfig.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'craftName',
        label: 'label.mintal.prd.mintalMesPrdCraftConfig.grid.craftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdCraftConfig.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdCraftConfig.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    craftIdFilter : '',
    craftNameFilter : '',
    locationIdFilter : '',
    locationNameFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'craftNameFilter',
        label: 'label.mintal.prd.mintalMesPrdCraftConfig.filter.craftName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdCraft'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"craftId": "id"}'
                }
        },
        {
        key: 'locationNameFilter',
        label: 'label.mintal.prd.mintalMesPrdCraftConfig.filter.locationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId": "id"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'craftName',
        label: 'label.mintal.prd.mintalMesPrdCraftConfig.entity.craftName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdCraft'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"craftId": "id"}'
                }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdCraftConfig.entity.locationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'imfMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"locationId": "id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdCraftConfig.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdCraftConfig, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
